import { FONT, RADIUS } from "@/styles/common";
import { Center, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomCenter = styled(Center)`
    & .date_search_bar_container {
        position: relative;
        color: ${({ theme }) => theme.COLOR.black};
        background: ${({ theme }) => theme.COLOR.white};
        border: 1px solid ${({ theme }) => theme.COLOR.text[300]};
        ${RADIUS(4)}

        & .dayNight {
            border: 1px solid ${({ theme }) => theme.COLOR.text[300]};
        }

        & .date_search_bar_button_box {
            position: absolute;
            right: 0;
            border-left: 1px dotted ${({ theme }) => theme.COLOR.black};

            & button {
                color: ${({ theme }) => theme.COLOR.white};
                background: ${({ theme }) => theme.COLOR.black};
                ${FONT("pretendard", 16, 500)}

                &:hover {
                    background: ${({ theme }) => theme.COLOR.text[300]};
                }
            }
        }
    }
`;

export const CustomText = styled(Text)`
    ${FONT("pretendard", 24, 700)}
`;
